export default __webpack_public_path__ + "static/media/mob-full-pariuriplus.0386da6a.png";